import { render, staticRenderFns } from "./Inscricao.vue?vue&type=template&id=22e5dc78&scoped=true"
import script from "./Inscricao.vue?vue&type=script&lang=js"
export * from "./Inscricao.vue?vue&type=script&lang=js"
import style0 from "./Inscricao.vue?vue&type=style&index=0&id=22e5dc78&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e5dc78",
  null
  
)

export default component.exports